export default __webpack_public_path__ + "static/media/feed.418c48d2.svg";